import type { Episode } from '@/types/video';

interface EpisodeListProps {
  episodes: Episode[];
  currentId: string;
  onChange: (episode: Episode) => void;
}

export default function EpisodeList({ episodes, currentId, onChange }: EpisodeListProps) {
  if (episodes.length <= 1) {
    return (
      <div className="rounded-lg bg-background-100 border border-background-200/70 p-5">
        <h2 className="font-heading text-base font-bold text-foreground-950">播放</h2>
        <p className="mt-2 text-sm text-foreground-600">
          本片为单片内容，点击上方播放按钮即可观看演示画面。
        </p>
      </div>
    );
  }

  return (
    <div className="rounded-lg bg-background-100 border border-background-200/70 p-5">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading text-base font-bold text-foreground-950">选集</h2>
        <span className="text-xs text-foreground-500">共 {episodes.length} 集</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
        {episodes.map((episode) => (
          <button
            key={episode.id}
            type="button"
            onClick={() => onChange(episode)}
            className={`px-3 py-2 rounded-md text-xs text-left line-clamp-1 transition-colors cursor-pointer ${
              currentId === episode.id
                ? 'bg-primary-500 text-background-950 font-semibold'
                : 'bg-background-200/60 text-foreground-700 hover:bg-background-300/60'
            }`}
          >
            {episode.title}
          </button>
        ))}
      </div>
    </div>
  );
}